module.exports = __webpack_public_path__ + "h5/img/login-bg.064b5074.png";